(function () {
  const moduleKey = "__nkStylingFormulaRuntime";
  const existingRuntime = window[moduleKey];

  if (existingRuntime && typeof existingRuntime.init === "function") {
    existingRuntime.init(document);
    return;
  }

  function matchesCategory(panel, category) {
    if (category === "all") return true;
    const values = (panel.getAttribute("data-sf-categories") || "")
      .split("|")
      .map((item) => item.trim())
      .filter(Boolean);
    return values.includes(category);
  }

  function initTabs(root) {
    root.querySelectorAll("[data-sf-tabs]").forEach((tabs) => {
      if (tabs.dataset.sfTabsBound === "true") return;
      tabs.dataset.sfTabsBound = "true";

      const section = tabs.closest("[data-sf-look-section]");
      if (!section) return;

      const buttons = Array.from(tabs.querySelectorAll("[data-sf-tab]"));
      const panels = Array.from(
        section.querySelectorAll("[data-sf-look-panel]"),
      );

      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          const category = button.getAttribute("data-sf-tab") || "all";
          buttons.forEach((item) =>
            item.setAttribute(
              "aria-selected",
              item === button ? "true" : "false",
            ),
          );
          panels.forEach((panel) => {
            panel.hidden = !matchesCategory(panel, category);
            panel.classList.toggle("is-active", !panel.hidden);
          });

          window.requestAnimationFrame(() => {
            panels
              .filter((panel) => !panel.hidden)
              .forEach((panel) => {
                panel
                  .querySelectorAll("[data-sf-products-track]")
                  .forEach((track) => {
                    track.dispatchEvent(new Event("scroll"));
                  });
              });
          });
        });
      });
    });
  }

  function productCarouselsIn(root) {
    if (!root) return [];
    const carousels = Array.from(
      root.querySelectorAll("[data-sf-product-carousel]"),
    );
    if (root.matches && root.matches("[data-sf-product-carousel]"))
      carousels.unshift(root);
    return carousels;
  }

  function initProductCarousels(root) {
    productCarouselsIn(root).forEach((carousel) => {
      if (carousel.dataset.sfProductCarouselBound === "true") return;

      const track = carousel.querySelector("[data-sf-products-track]");
      const previous = carousel.querySelector("[data-sf-product-prev]");
      const next = carousel.querySelector("[data-sf-product-next]");
      const controls = carousel.querySelector("[data-sf-product-controls]");
      if (!track || !previous || !next) return;

      carousel.dataset.sfProductCarouselBound = "true";

      const update = () => {
        const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        const hasOverflow = maxScroll > 2;
        carousel.classList.toggle("is-overflowing", hasOverflow);
        if (controls) controls.hidden = !hasOverflow;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll - 2;
      };

      const move = (direction) => {
        track.scrollBy({
          left: direction * Math.max(track.clientWidth, 1),
          behavior: "smooth",
        });
      };

      const handlePrevious = () => move(-1);
      const handleNext = () => move(1);

      previous.addEventListener("click", handlePrevious);
      next.addEventListener("click", handleNext);
      track.addEventListener("scroll", update, { passive: true });

      let observer;
      if ("ResizeObserver" in window) {
        observer = new ResizeObserver(update);
        observer.observe(track);
      } else {
        window.addEventListener("resize", update, { passive: true });
      }

      carousel.sfProductCarouselCleanup = function () {
        previous.removeEventListener("click", handlePrevious);
        next.removeEventListener("click", handleNext);
        track.removeEventListener("scroll", update);
        if (observer) {
          observer.disconnect();
        } else {
          window.removeEventListener("resize", update);
        }
        delete carousel.sfProductCarouselCleanup;
        delete carousel.dataset.sfProductCarouselBound;
      };

      update();
    });
  }

  function destroyProductCarousels(root) {
    productCarouselsIn(root).forEach((carousel) => {
      if (typeof carousel.sfProductCarouselCleanup === "function") {
        carousel.sfProductCarouselCleanup();
      }
    });
  }

  function normalizeEmbedUrl(rawUrl, provider) {
    if (!rawUrl) return "";
    try {
      const url = new URL(rawUrl, window.location.origin);
      const mediaProvider = provider || "auto";
      if (mediaProvider === "youtube" || url.hostname.includes("youtube.com")) {
        const id = url.searchParams.get("v");
        if (id)
          return (
            "https://www.youtube.com/embed/" +
            encodeURIComponent(id) +
            "?autoplay=1&rel=0"
          );
      }
      if (mediaProvider === "youtube" || url.hostname.includes("youtu.be")) {
        const id = url.pathname.replace("/", "");
        if (id)
          return (
            "https://www.youtube.com/embed/" +
            encodeURIComponent(id) +
            "?autoplay=1&rel=0"
          );
      }
      if (
        mediaProvider === "instagram" ||
        url.hostname.includes("instagram.com")
      ) {
        const parts = url.pathname.split("/").filter(Boolean);
        const type = parts[0];
        const id = parts[1];
        if ((type === "p" || type === "reel" || type === "tv") && id) {
          return (
            "https://www.instagram.com/" +
            encodeURIComponent(type) +
            "/" +
            encodeURIComponent(id) +
            "/embed"
          );
        }
      }
      if (
        mediaProvider === "facebook" ||
        url.hostname.includes("facebook.com") ||
        url.hostname.includes("fb.watch")
      ) {
        return (
          "https://www.facebook.com/plugins/video.php?href=" +
          encodeURIComponent(rawUrl) +
          "&show_text=false&autoplay=true"
        );
      }
      if (url.hostname.includes("vimeo.com")) {
        const id = url.pathname.split("/").filter(Boolean).pop();
        if (id)
          return (
            "https://player.vimeo.com/video/" +
            encodeURIComponent(id) +
            "?autoplay=1"
          );
      }
      return rawUrl;
    } catch (error) {
      return rawUrl;
    }
  }

  function loadExternalMedia(card) {
    const target = card.querySelector("[data-sf-external-player]");
    if (!target || target.childElementCount > 0) return;

    const provider = card.getAttribute("data-sf-external-provider") || "auto";
    const rawUrl = card.getAttribute("data-sf-external-url");
    const url = normalizeEmbedUrl(rawUrl, provider);
    if (!url) return;

    if (
      url.includes("youtube.com/embed") ||
      url.includes("player.vimeo.com") ||
      url.includes("instagram.com") ||
      url.includes("facebook.com/plugins/video.php")
    ) {
      const iframe = document.createElement("iframe");
      iframe.src = url;
      iframe.allow = "autoplay; encrypted-media; picture-in-picture";
      iframe.allowFullscreen = true;
      iframe.title =
        card.getAttribute("data-sf-video-title") || "Styling formula media";
      target.appendChild(iframe);
    } else {
      const video = document.createElement("video");
      video.src = url;
      video.controls = true;
      video.playsInline = true;
      video.autoplay = true;
      target.appendChild(video);
      video.play().catch(function () {});
    }

    card.classList.add("is-playing");
  }

  function initExternalMedia(root) {
    root.querySelectorAll("[data-sf-external-media]").forEach((card) => {
      if (card.dataset.sfExternalBound === "true") return;
      card.dataset.sfExternalBound = "true";

      card.addEventListener("click", (event) => {
        if (event.target.closest("a")) return;
        loadExternalMedia(card);
      });
    });
  }

  function initMotionCards(root) {
    root.querySelectorAll("[data-sf-video-card]").forEach((card) => {
      if (card.dataset.sfVideoBound === "true") return;
      card.dataset.sfVideoBound = "true";

      card.addEventListener("click", (event) => {
        if (event.target.closest("a")) return;
        const target = card.querySelector("[data-sf-video-player]");
        if (!target || target.childElementCount > 0) return;

        const templates = Array.from(
          card.querySelectorAll("template[data-sf-video-template]"),
        );
        const wantedTemplate = window.matchMedia("(max-width: 749px)").matches
          ? "mobile"
          : "desktop";
        const template =
          templates.find(
            (item) =>
              item.getAttribute("data-sf-video-template") === wantedTemplate,
          ) || templates[0];
        if (template) {
          const clone = template.content.cloneNode(true);
          const video = clone.querySelector("video");
          if (video) {
            video.setAttribute("controls", "");
            video.setAttribute("playsinline", "");
            video.setAttribute("autoplay", "");
          }
          target.appendChild(clone);
          const insertedVideo = target.querySelector("video");
          if (insertedVideo) insertedVideo.play().catch(function () {});
          card.classList.add("is-playing");
          return;
        }

        const url = normalizeEmbedUrl(
          card.getAttribute("data-sf-video-url"),
          card.getAttribute("data-sf-video-provider"),
        );
        if (!url) return;

        if (
          url.includes("youtube.com/embed") ||
          url.includes("player.vimeo.com") ||
          url.includes("instagram.com") ||
          url.includes("facebook.com/plugins/video.php")
        ) {
          const iframe = document.createElement("iframe");
          iframe.src = url;
          iframe.allow = "autoplay; encrypted-media; picture-in-picture";
          iframe.allowFullscreen = true;
          iframe.title =
            card.getAttribute("data-sf-video-title") || "Styling formula video";
          target.appendChild(iframe);
        } else {
          const video = document.createElement("video");
          video.src = url;
          video.controls = true;
          video.playsInline = true;
          video.autoplay = true;
          target.appendChild(video);
          video.play().catch(function () {});
        }
        card.classList.add("is-playing");
      });
    });
  }

  function init(root) {
    initTabs(root);
    initProductCarousels(root);
    initMotionCards(root);
    initExternalMedia(root);
  }

  window[moduleKey] = { init: init };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        init(document);
      },
      { once: true },
    );
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    destroyProductCarousels(event.target);
  });
})();
